<template>
  <figure
    :class="['picture', data.nobg !== undefined ? 'picture--nobg' : '']"
    :style="{ marginBottom: `${marginBottom}px` }"
  >
    <div
      :class="['picture__container', data.tagImg ? 'picture__container--img' : 'picture__container--div']"
      :js-anim="lazy ? animation : false"
      :style="{ position: data.tagImg ? 'relative' : 'absolute' }"
      :js-rotation="data.rotation !== undefined && data.rotation !== '' ? data.rotation : 0"
      :js-lottie="lottieBg"
    >
      <img
        :js-lazy="lazy ? data.pictureUrl : false"
        :src="!lazy ? data.pictureUrl : false"
        :alt="getImageAlt(data.pictureUrl)"
        :js-target="lazy ? 'pictureimg' : false"
      >
      <div
        :class="['picture__image-bg']"
        :js-lazy="lazy ? data.pictureUrl : false"
        :style="{ backgroundImage: !lazy ? `url(${data.pictureUrl}` : false }"
        :js-target="lazy ? 'pictureimg' : false"
      >
      </div>
      <div class="picture__bg-animation lottie" v-if="!data.tagImg" js-target="picturebg" :js-lottieref="lottieRef"></div>
    </div>

    <figcaption
      :data-position="data.position !== undefined ? data.position : false"
      v-if="
        (data.title !== undefined && data.title.length > 0) ||
        (data.subtitle !== undefined && data.subtitle.length > 0)
      "
    >
      <h4 v-if="data.title !== ''" v-html="data.title" js-anim="title">{{ data.title }}</h4>

      <div v-if="data.subtitle !== ''" v-html="data.subtitle" js-anim="text">{{ data.subtitle }}</div>

      <ul class="picture__social" v-if="$route.name === 'workshops' && data.twitter !== undefined && (data.twitter !== '' || data.website !== '')">
        <li v-if="data.twitter !== ''">
          <a
            class="ui-link"
            data-hover="Twitter"
            :href="data.twitter"
            rel="noopener"
            target="_blank"
            js-anim="text"
          >
            Twitter
          </a>
        </li>
        <li v-if="data.website !== ''">
          <a
            class="ui-link"
            data-hover="Website"
            :href="data.website"
            rel="noopener"
            target="_blank"
            js-anim="text"
          >
            Website
          </a>
        </li>
      </ul>
    </figcaption>
  </figure>
</template>

<script>
import { mapGetters } from 'vuex';
import { qs } from '@/scripts/utils';


export default {
  name: 'pictureComp',

  props: {
    data: {
      type: Object,
      required: true,
    },

    lazy: {
      type: Boolean,
      required: false,
      default: true,
    },

    animation: {
      type: String,
      required: false,
      default: 'picture',
    },

    lottieBg: {
      type: String,
      required: false,
      default: 'long',
    },

    lottieRef: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      marginBottom: 0,
    };
  },

  computed: {
    ...mapGetters(['getImageAlt']),
  },

  mounted() {
    this.getMarginBottom();
    this.$eventHub.$on('windowResize', this.getMarginBottom);
  },

  methods: {
    getMarginBottom() {
      if (qs('figcaption', this.$el) !== null) {
        this.marginBottom = Math.round(qs('figcaption', this.$el).getBoundingClientRect().height + 40);
      }
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('windowResize', this.getMarginBottom);
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

figure {
  position: relative;
  width: 100%;
  z-index: 0;

  .picture__container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    &.picture__container--img {
      height: auto;
    }

    .picture__image-bg {
      position: relative;
      width: 100%;
      height: 100%;
      transform: scale(0.8);

      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;

      z-index: 5;
    }

    .picture__bg-animation {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      z-index: -1;

      @at-root [data-theme="pink"] &:not([js-target]) {
        background-color: $color-pink;
      }

      @at-root [data-theme="blue"] &:not([js-target]) {
        background-color: $color-blue;
      }

      @at-root [data-theme="red"] &:not([js-target]) {
        background-color: $color-red;
      }

      @at-root [data-theme="azure"] &:not([js-target]) {
        background-color: $color-azure;
      }

      @at-root [data-theme="yellow"] &:not([js-target]) {
        background-color: $color-yellow;
      }

      @at-root [data-theme="ocher"] &:not([js-target]) {
        background-color: $color-ocher;
      }
    }

    img {
      display: inline-block;
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
    }

    &:not(.picture__container--img) {
      img {
        @include visually-hidden;
      }
    }

    &:not(.picture__container--div) {
      .picture__image-bg {
        @include visually-hidden;
      }
    }
  }

  figcaption {
    position: absolute;
    top: 100%;
    width: 100%;
    margin-top: 25px;

    padding: 0 20px;

    @include mq(ipadP) {
      padding: 0 20px;
      margin-top: 40px;
    }

    h4 {
      line-height: 1.2;
      margin-bottom: 15px;
      
      @include mq($until: ipadP) {
        font-size: 1.3rem;
      }

      @include mq(ipadP) {
        margin-top: 20px;
      }
    }

    @include mq(ds) {
      max-width: 512px;
    }

    &[data-position="right"] {
      @include mq(ds) {
        right: 0;
      }
    }

    .picture__social {
      margin: 20px 0 0 0;
      li {
        display: block;
        margin: 10px 0;
      }
    }
  }
}
</style>
<style lang="scss">
.picture__bg-animation.lottie svg {
  position: absolute;
  width: 100% !important;
  height: 100% !important;

  path {
    @at-root [data-theme="pink"] & {
    fill: $color-pink !important;
    }

    @at-root [data-theme="blue"] & {
      fill: $color-blue !important;
    }

    @at-root [data-theme="red"] & {
      fill: $color-red !important;
    }

    @at-root [data-theme="azure"] & {
      fill: $color-azure !important;
    }

    @at-root [data-theme="yellow"] & {
      fill: $color-yellow !important;
    }

    @at-root [data-theme="ocher"] & {
      fill: $color-ocher !important;
    }
  }
}
</style>
